import { http } from '@/http'

const API_RESOURCE_LANGUAGE = 'Table/tLanguage/GetAll'

export default {
  get () {
    return http.get(API_RESOURCE_LANGUAGE)
  }
}
